// src/Pages/Dashboard/widgets/Overview/RecentActivity.jsx
import React, { useMemo } from 'react';
import '../../../../Stylesheets/Dashboard/RecentActivity.css';
import { useNavigate } from 'react-router-dom';

const TYPE_META = {
  attendance: { label: 'Attendance', chip: 'chip-attendance' },
  payment: { label: 'Payment', chip: 'chip-payment' },
  expense_create: { label: 'Expense', chip: 'chip-expense' },
  material_receive: { label: 'Material Received', chip: 'chip-mreceive' },
  material_usage: { label: 'Material Used', chip: 'chip-musage' },
  material_bill: { label: 'Material Bill', chip: 'chip-mbill' },
};

const placeholder =
  'https://wordpress.bricknbolt.com/blogs-and-articles/wp-content/uploads/sites/2/2024/07/House-Construction-in-India.webp';

const fmtRelative = (iso) => {
  if (!iso) return '';
  const now = Date.now();
  const t = new Date(iso).getTime();
  const diff = Math.max(1, Math.floor((now - t) / 1000)); // seconds
  if (diff < 60) return `${diff}s ago`;
  const m = Math.floor(diff / 60);
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  const d = Math.floor(h / 24);
  if (d < 7) return `${d}d ago`;
  return new Date(iso).toLocaleDateString('en-GB', { day: '2-digit', month: 'short' });
};

const RecentActivity = ({ items = [], projects = [] }) => {
  const navigate = useNavigate();

  // projectId -> project
  const projectMap = useMemo(() => {
    const m = new Map();
    projects.forEach((p) => m.set(String(p._id || p.id), p));
    return m;
  }, [projects]);

  if (!items.length) {
    return (
      <div className="ra-wrap">
        <h3 className="ra-title">Recent Activity</h3>
        <div className="ra-empty">No recent activity yet.</div>
      </div>
    );
  }

  return (
    <div className="ra-wrap">
      <h3 className="ra-title">Recent Activity</h3>

      <div className="ra-grid">
        {items.map((item) => {
          const proj = projectMap.get(String(item.projectId)) || {};
          const img = item.imageUrl || proj.image || placeholder;
          const projectName = proj.name || 'Project';
          const typeMeta = TYPE_META[item.type] || { label: item.type, chip: 'chip-default' };

          return (
            <article className="ra-card" key={item._id || `${item.projectId}-${item.createdAt}`}>
              <div className="ra-media">
                <img src={img} alt={`${projectName} activity`} />
                <span className={`ra-chip ${typeMeta.chip}`}>{typeMeta.label}</span>
              </div>

              <div className="ra-content">
                <h4 className="ra-project">{projectName}</h4>
                <p className="ra-message">{item.message}</p>

                <div className="ra-footer">
                  <span className="ra-time" title={item.createdAt}>
                    {fmtRelative(item.createdAt)}
                  </span>

                  <button
                    className="ra-btn"
                    disabled={!proj?._id}
                    title={proj?._id ? 'Open project' : 'Project not found'}
                    onClick={() => navigate(`/dashboard/project/${proj._id}`)}
                  >
                    View Project →
                  </button>
                </div>
              </div>
            </article>
          );
        })}
      </div>
    </div>
  );
};

export default RecentActivity;
